import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'vaelg-hund';
        case 'vaelg-hund':
            return 'om-skaden';
        case 'om-skaden':
            return 'om-ejeren';
        case 'om-ejeren':
            return 'dato';
        case 'dato':
            return 'adresse';
        case 'adresse':
            return 'skete-skaden-under-leg';
        case 'skete-skaden-under-leg':
            return 'hvilke-hunde-var-i-snor';
        case 'hvilke-hunde-var-i-snor':
            return 'beskriv-haendelsen';
        case 'beskriv-haendelsen':
            return 'beskriv-skaderne';
        case 'beskriv-skaderne':
            return 'ansvar';
        case 'ansvar':
            if (getValueOrDefault(formConfig, formValues, 'hvemforrsagedeskaden').value === 'Min hund') {
                return 'blev-hunden-passet';
            } else {
                return 'om-ansvar';
            }
        case 'blev-hunden-passet':
            if (getValueOrDefault(formConfig, formValues, 'blevdinhundpassetafejerenafdetdelagte').value === 'Ja') {
                return 'pasningstidspunkt';
            } else {
                return 'om-ansvar';
            }
        case 'pasningstidspunkt':
            return 'om-ansvar';
        case 'om-ansvar':
            return 'politianmeldelse';
        case 'politianmeldelse':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Ja') {
                return 'om-politianmeldelsen';
            } else {
                return 'dokumentation';
            }
        case 'om-politianmeldelsen':
            return 'samtykke';
        case 'samtykke':
            return 'dokumentation';
        case 'dokumentation':
            return 'andet-selskab';
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            } else {
                return 'om-dig';
            }
        case 'hvilket-selskab':
            return 'om-dig';
        case 'om-dig':
            return 'resume';
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
